import CryptoJS from 'crypto-js';
import { CRYPT_KEY } from '../constants/constants';

export function encodeData(data: unknown): string {
	const json: string = encrypt(JSON.stringify(data));
	const bytes: Uint8Array = new TextEncoder().encode(json);
	let binary: string = '';
	bytes.forEach((b: number): string => (binary += String.fromCharCode(b)));
	return btoa(binary);
}

export function decodeData<T,>(encoded: string): T | null {
	try {
		const binary: string = atob(encoded);
		const bytes: Uint8Array = Uint8Array.from(binary, (c: string): number => c.charCodeAt(0));
		const json: string = decrypt(new TextDecoder().decode(bytes));
		return JSON.parse(json) as T;
	} catch (err) {
		console.error("Errore decodifica Base64:", err);
		return null;
	}
}

function encrypt(data: string): string {
	return CryptoJS.AES.encrypt(data, CRYPT_KEY).toString();
}

function decrypt(ciphertext: any): any {
	const bytes: CryptoJS.lib.WordArray = CryptoJS.AES.decrypt(ciphertext, CRYPT_KEY);
	return bytes.toString(CryptoJS.enc.Utf8);
}
